const INITIAL_STATE = {
    list: {
        status: 'loading',
        data: []
    },
    event: {
    }
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'EVENTS_LIST_STATUS':
            return {
                    ...state,
                    list: {
                        ...state.list,
                        status: action.payload
                    }
                }
        case 'EVENTS_LIST_DATA':
            return {
                    ...state,
                    list: {
                        ...state.list,
                        data: action.payload
                    }
                }
        case 'EVENT_STATUS': 
                return {
                    ...state,
                    event: {
                        ...state.event,
                        [action.payload.token]: {
                            'status': action.payload.status
                        } 
                    }
                }
        case 'EVENT_LOADED': 
        return {
            ...state,
            event: {
                ...state.event,
                [action.payload.token]: {
                    ...state.event[action.payload.token],
                    data: action.payload.data,
                    status: 'done'
                } 
            }
        }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/modules/reducers/eventsReducer.js